/*eslint-disable react/no-danger*/
import React, {PropTypes} from 'react';
import CheckBoxInput from '../common/CheckBoxInput';
import Button from '../common/Button';


const EstablishmentSubmitForm = ({
  form,
  hideSubmitPage,
  resubmissionReason,
  onChange,
  onSubmit,
  isResubmit,
  isActive,
  numOfEstablishments,
  onClick
}) => {
  let buttonValue = isResubmit ? "Re-Submit Data" : "Submit Data";
  let resubmissionQuestion = null;
  let checkBoxQuestion = null;
  let title = `Confirm Submission of Data for ${numOfEstablishments} Establishment(s)`;
  if (isResubmit) {
    title = `Confirm Re-Submission of Data for ${numOfEstablishments} Establishment(s)`;
  }
  if (form.formQuestions) {
    form.formQuestions.forEach(question => {
      question.questionParts.map(questionPart => {
        let type = questionPart.questionPartType;
        if (questionPart.questionPartName === 'resubmissionReason'
          && isResubmit === true) {
          resubmissionQuestion = (
            <div className="question-part"
                  key={questionPart.questionPartName}>
              <div className="resubmission-label">
                {questionPart.questionPartLabel}
              </div>
              <textarea
                rows="4"
                cols="80"
                maxLength="250"
                placeholder="Max Limit 250 Characters"
                onChange={onChange}
                name={questionPart.questionPartName}
                className="resubmission-textarea"
                value={resubmissionReason}/>
              <div
                dangerouslySetInnerHTML={{__html: questionPart.questionPartContextHelp}}/>
            </div>);
        }
        else if (type === '1') {
          checkBoxQuestion = (
            <div className="question-part"
                  key={questionPart.questionPartName}>
                <CheckBoxInput
                  name={questionPart.questionPartName || ""}
                  options={questionPart.questionPartOptions}
                  onChange={onClick}
                />
                <div
                  dangerouslySetInnerHTML={{__html: questionPart.questionPartContextHelp}}/>
            </div>
          );
        }
      });
    });
  }
  return (
    <div className="submit-form-modal-container">
      <h4 id="submit-establishment-title">{title}</h4>
      <form id="submit-establishment-container">
        {resubmissionQuestion}
        <div className="legal-statement"
             dangerouslySetInnerHTML={{__html: form.formPageHelp}}/>
        {checkBoxQuestion}
        <div className="submit-establishment">
          <a
            disabled={false}
            onClick={hideSubmitPage}>
            Cancel
          </a>
          <Button
            value={buttonValue}
            disabled={isActive}
            onClick={onSubmit}
            className="submit-establishment-btn"
          />
        </div>
      </form>
    </div>
  );

};
EstablishmentSubmitForm.propTypes = {
  form: PropTypes.object.isRequired,
  hideSubmitPage: PropTypes.func.isRequired,
  resubmissionReason: PropTypes.string.isRequired,
  isResubmit: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  numOfEstablishments: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};
export default EstablishmentSubmitForm;



/** WEBPACK FOOTER **
 ** ./src/components/establishment/EstablishmentSubmitForm.js
 **/